export enum WaterAdditionByTravelMessages {
  title = "waterAdditionByTravel.title",
  waterAdditionByTravel = "waterAdditionByTravel.waterAdditionByTravel",
  filterTitle = "waterAdditionByTravel.filterTitle",
  fleetCode = "waterAdditionByTravel.fleetCode",
  licensePlate = "waterAdditionByTravel.licensePlate",
  startDate = "waterAdditionByTravel.startDate",
  finishDate = "waterAdditionByTravel.finishDate",
  driver = "waterAdditionByTravel.driver",
  document = "waterAdditionByTravel.document",
  volume = "waterAdditionByTravel.volume",
  preDischarge = "waterAdditionByTravel.preDischarge",
  postDischarge = "waterAdditionByTravel.postDischarge",
  reassignedPostDischarge = "waterAdditionByTravel.reassignedPostDischarge",
  originTravelDoc = "waterAdditionByTravel.originTravelDoc",
  noDataFound = "waterAdditionByTravel.noDataFound",
  minWater = "waterAdditionByTravel.minWater",
  maxWater = "waterAdditionByTravel.maxWater",
  waterTotal = "waterAdditionByTravel.waterTotal",
  waterAdditionTitle = "waterAdditionByTravel.waterAdditionTitle",
  analyticTabTitle = "waterAdditionByTravel.analyticTabTitle",
  syntheticTabTitle = "waterAdditionByTravel.syntheticTabTitle"
}

export interface TranslationWaterAdditionByTravelMessages {
  [WaterAdditionByTravelMessages.title]: string;
  [WaterAdditionByTravelMessages.waterAdditionByTravel]: string;
  [WaterAdditionByTravelMessages.filterTitle]: string;
  [WaterAdditionByTravelMessages.fleetCode]: string;
  [WaterAdditionByTravelMessages.licensePlate]: string;
  [WaterAdditionByTravelMessages.startDate]: string;
  [WaterAdditionByTravelMessages.finishDate]: string;
  [WaterAdditionByTravelMessages.driver]: string;
  [WaterAdditionByTravelMessages.document]: string;
  [WaterAdditionByTravelMessages.volume]: string;
  [WaterAdditionByTravelMessages.preDischarge]: string;
  [WaterAdditionByTravelMessages.postDischarge]: string;
  [WaterAdditionByTravelMessages.reassignedPostDischarge]: string;
  [WaterAdditionByTravelMessages.originTravelDoc]: string;
  [WaterAdditionByTravelMessages.noDataFound]: string;
  [WaterAdditionByTravelMessages.minWater]: string;
  [WaterAdditionByTravelMessages.maxWater]: string;
  [WaterAdditionByTravelMessages.waterTotal]: string;
  [WaterAdditionByTravelMessages.waterAdditionTitle]: string;
  [WaterAdditionByTravelMessages.analyticTabTitle]: string;
  [WaterAdditionByTravelMessages.syntheticTabTitle]: string;
}
